import Joi from 'joi';

export default Joi.object({
  creator_name: Joi.required(),
  requester_name: Joi.string().required(),
  requester_id: Joi.number().required(),
  sponsor_id: Joi.number().required(),
  existing_vendor: Joi.string().valid('true', 'false').required(),
  doing_business_as: Joi.string().allow(null),
  vendor_type_category: Joi.string()
    .required()
    .valid('Direct', '3rd Party', 'Hybrid'),
  /* Direct is displayed Direct Factory / Manufacturer
   * 3rd Party is displayed Importer / Wholesaler
   * Hybrid is displayed Agent
   */
  legal_name: Joi.string().required(),
  divisions: Joi.array()
    .items(Joi.string().valid('Women', 'Men', 'Kids', 'Beauty'))
    .min(1)
    .required(),
  primary_contact_firstname: Joi.string().required(),
  primary_contact_lastname: Joi.string().required(),
  primary_contact_email: Joi.string()
    .email({ tlds: { allow: false } })
    .required(),
  primary_contact_title: Joi.string().allow('').optional(),
});
